import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Gamepad2, ChefHat } from 'lucide-react';
import { TodayTopPlayer } from './TodayTopPlayer';

const Contest = () => {
  return (
    <section className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="bg-[#FFD84D] rounded-3xl crunch-shadow p-8 md:p-14 relative overflow-hidden noise">
          <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-[#E63946] wobble" />
          <div className="absolute -bottom-8 -left-8 w-40 h-40 rounded-full bg-[#2A9D8F] float" />

          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-[#1a1a1a] text-[#FFF4E6] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
                <span className="w-2 h-2 bg-[#E63946] rounded-full animate-pulse" /> Crunch Contest is Live
              </div>
              <h2 className="font-display text-5xl md:text-7xl mt-4 uppercase leading-[0.9]">
                Win a <span className="italic">real</span><br /> Hamper!
              </h2>
              <p className="mt-5 text-lg font-brico max-w-md">
                Top 5 players get a TruCrunch Hamper worth <span className="font-bold">₹999</span>. India only. One entry per email. Best score counts.
              </p>
              <div className="flex flex-wrap gap-3 mt-6">
                <Link to="/play" className="btn-chunky primary">
                  <Gamepad2 size={18} /> Play Now
                </Link>
                <Link to="/leaderboard" className="btn-chunky outline">
                  <Trophy size={18} /> Leaderboard
                </Link>
              </div>
              <TodayTopPlayer />
            </div>

            <div className="bg-[#1a1a1a] text-[#FFF4E6] rounded-3xl crunch-shadow-sm p-6 md:p-8 text-center relative overflow-hidden">
              <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-[#E63946]/30" />
              <ChefHat size={40} className="mx-auto text-[#FFD84D]" />
              <div className="text-[10px] font-bold uppercase tracking-widest mt-3 opacity-70">Contest closes on</div>
              <div className="font-display text-4xl md:text-5xl mt-1 leading-[0.95]">Launch Day.</div>
              <p className="font-brico mt-3 opacity-80 max-w-xs mx-auto">The moment the first pack ships, we crown the top 5 crunchers and mail the hampers.</p>
              <div className="mt-4 inline-flex items-center gap-2 bg-[#FFD84D] text-[#1a1a1a] px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest">
                <span className="w-2 h-2 bg-[#E63946] rounded-full animate-pulse" /> Keep playing to stay on top
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contest;
